import Chart from 'chartjs';
import _ from 'underscore';
import moment from 'moment';
import i18n from 'l10n';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';

    var it = {
        /* TODO Replace with model fetch */
        pingUrl: '/CampaignCloud/UserInfo'
    };
    var isPostpaid = false;

    var queryOptions = {
        from: null, //long millis
        to: null, //long millis
        unit: null,
        window: null,
        dow: null //first day of week (0-Sunday ...)
    };
    it.options = {
        from: null, //moment
        to: null, //moment
        window: null,
        fromAll: null,
        toAll: null,
        unitAll: null,
        queryOptions: queryOptions
    };
    it.division = {
        all: {divisions: ['month'], def: 'month'},
        day: {divisions: ['hour'], def: 'hour'},
        week: {divisions: ['day'], def: 'day'},
        month: {divisions: ['week', 'day'], def: 'day'},
        year: {divisions: ['month', 'week'], def: 'month'}
    };

    it.moreLessDetails = function (inc) {
        var division = this.division[this.options.window];
        var curr = _.indexOf(division.divisions, this.options.queryOptions.unit);
        if (curr >= 0 && curr + inc >= 0 && curr + inc < division.divisions.length) { //paranoid check
            this.options.queryOptions.unit = division.divisions[curr + inc];
            $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
            this.refresh();
        }
    };

    it.setWindow = function (timegranule) {
        var now = moment();
        var previousWindow = this.options.window;
        var goingToDayFromEnclosingWindow = this.options.window !== 'day' && timegranule === "day" && now.isBetween(this.options.from, this.options.to);
        if (timegranule === "*day") timegranule = "day";

        this.options.window = timegranule;
        this.options.queryOptions.window = timegranule;
        var division = this.division[timegranule];
        this.options.queryOptions.unit = division.def;
        if (division.divisions.length === 1) {
            $(this.selector).find(".zoom-buttons").find('button').addClass('disabled');
        } else {
            $(this.selector).find(".zoom-buttons").find('button').removeClass('disabled');
            if (this.options.queryOptions.unit === _.first(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.minus').addClass('disabled');
            } else if (this.options.queryOptions.unit === _.last(division.divisions)) {
                $(this.selector).find(".zoom-buttons").find('.plus').addClass('disabled');
            }
        }
        if (timegranule === 'all') {
            this.options.queryOptions.unit = this.options.unitAll;
            this.options.from = this.options.fromAll;
            this.options.to = this.options.toAll;
            this.options.queryOptions.from = this.options.from.toDate().getTime();
            this.options.queryOptions.to = this.options.to.toDate().getTime();
            $(this.selector).find('.pagination').find('li').addClass('disabled');
            $(this.selector).find('.pagination').find('.spaces').html(i18n.t('reports.allbutton'));
        }
        else {
            if(previousWindow == null){
                //Set starting timeframe the start of current timeframe,
                //When loading the page for the first time
                this.options.from = now.startOf("week");
            }

            var startOf = previousWindow !== 'month' && goingToDayFromEnclosingWindow ? now.startOf("day") : this.options.from.clone().startOf(this.options.window);
            this.options.from = startOf;
            this.options.queryOptions.from = startOf.toDate().getTime();
            var endOf = startOf.clone().endOf(this.options.window);
            this.options.to = endOf;
            this.options.queryOptions.to = endOf.toDate().getTime();

            var startOfString = startOf.format('ll');
            var endOfString = endOf.format('ll');
            $(this.selector).find('.pagination').find('li').removeClass('disabled');
            $(this.selector).find('.pagination').find('.spaces').html(startOfString + ' - ' + endOfString);
        }
    };

    it.init = function (selector, viewType) {
        var self = this;
        this.options.queryOptions.dow = moment().localeData().firstDayOfWeek();
        this.viewType = viewType;
        this.selector = selector;

        $(this.selector).find(".timegranule-buttons > button").on('click', function (evt) {
            var btn = $(evt.currentTarget);
            var tg = btn.attr("data-timegranule");

            //set the clicked button to active
            btn.parent().find(".active").removeClass("active");
            btn.addClass("active");

            self.setWindow(tg);
            self.refresh();
        });

        $(this.selector).find('.pagination').find('.prev').on('click', function () {
            if (!$(this).hasClass('disabled')) {
                self.options.from.subtract(1, self.options.window + 's');
                self.setWindow(self.options.window);
                self.refresh();
            }
        });

        $(this.selector).find('.pagination').find('.next').on('click', function () {
            if (!$(this).hasClass('disabled')) {
                self.options.from.add(1, self.options.window + 's');
                self.setWindow(self.options.window);
                self.refresh();
            }
        });

        $(this.selector).find(".zoom-buttons").find('.minus').on('click', function () {
            if (!$(this).hasClass('disabled')) {
                self.moreLessDetails(-1);
            }
        });

        $(this.selector).find(".zoom-buttons").find('.plus').on('click', function () {
            if (!$(this).hasClass('disabled')) {
                self.moreLessDetails(+1);
            }
        });

        $.ajaxDefaultQ({
            url: self.pingUrl,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            success: function (json) {
                var dateFrom = moment(json.creationDate.millis).startOf('month');
                var one_day = 1000 * 60 * 60 * 24;
                self.options.fromAll = dateFrom;
                var date2_ms = moment().toDate().getTime();
                self.options.toAll = moment().endOf('day');
                var difference_ms = date2_ms - dateFrom;
                // Convert back to days and check
                if (Math.round(difference_ms / one_day) < 30) {
                    self.options.unitAll = "day";
                }
                else if (Math.round(difference_ms / one_day) < 49) {
                    self.options.unitAll = "week";
                }
                else {
                    self.options.unitAll = "month";
                }

                isPostpaid = json.postpaid;

                $(self.selector).find(".timegranule-buttons").find("[data-timegranule='week']").addClass('active');
                self.setWindow('week');
                self.refresh();
            }
        });

    };

    it.refresh = function () {

        $.ajaxDefaultQ({
            url: '/CampaignCloud/RememberMeController/ping',
            type: 'GET',
            dataType: "json"
        }).done(function (response) {
            if (response.status === 'success') {

                console.log('Going to ' + it.options.from.format('ll') + '(' + it.options.queryOptions.from + ') - ' + it.options.to.format('ll') + '(' + it.options.queryOptions.to + ') window=' + it.options.window + ' unit=' + it.options.queryOptions.unit + ' dow=' + it.options.queryOptions.dow);

                //TODO: it.viewType

                var type = it.viewType === "engagement" ? "Engagement" : "Satisfaction";
                var handlerServices = $.ajaxDefaultQ({
                    url: '/CampaignCloud/Report/' + type + 'ServiceChart',
                    type: 'POST',
                    data: JSON.stringify(it.options.queryOptions),
                    contentType: 'application/json',
                    dataType: 'json'
                }).done(function (json) {
                }).fail(function (response) {
                    console.log(response);
                });

                $.when(handlerServices).done(function (json) {
                    if (json.unit) {
                        $(it.selector).find('#serviceChartXAxisLabel').text(i18n.t("reports.label-" + json.unit));
                    }

                    if (it.serviceChart) {
                        it.serviceChart.destroy();
                    }

                    var lengthOfData = it.viewType === "engagement" ? json.url.length : json.greatScores.length;
                    var labels = i18n.labels(it.options.from, it.options.window, it.options.queryOptions.unit, lengthOfData);

                    var dataArray = it.viewType === "engagement"
                        ? [
                            {"label": i18n.t('engagement.urlClicked'), "color": ch.colors.mauveUno, "data": json.url},
                            {
                                "label": i18n.t('engagement.filesDownloaded'),
                                "color": ch.colors.blueDue,
                                "data": json.downloads
                            },
                            {
                                "label": i18n.t('engagement.vouchersRedeemed'),
                                "color": ch.colors.greenTre,
                                "data": json.vouchers
                            },
                            {
                                "label": i18n.t('engagement.surveysSubmitted'),
                                "color": ch.colors.orangeCinque,
                                "data": json.surveyInit
                            }
                        ]
                        : [
                            {
                                "label": i18n.t('satisfaction.greatLabel'),
                                "color": ch.colors.mauveUno,
                                "data": json.greatScores
                            },
                            {
                                "label": i18n.t('satisfaction.okayLabel'),
                                "color": ch.colors.blueDue,
                                "data": json.okayScores
                            },
                            {
                                "label": i18n.t('satisfaction.notGoodLabel'),
                                "color": ch.colors.greenTre,
                                "data": json.notGoodScores
                            }
                        ];

                    var datasets = [];
                    _.forEach(dataArray, function (obj) {
                        datasets.push({
                            label: obj.label,
                            fillColor: obj.color.transparent,
                            strokeColor: obj.color.solid,
                            pointColor: obj.color.solid,
                            pointStrokeColor: "#fff",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: obj.color.solid,
                            data: obj.data
                        });
                    });

                    var data = {
                        labels: labels,
                        datasets: datasets
                    };
                    var options = {
                        responsive: true,
                        legendTemplate: "<% %><div style=\"text-align:center;\"><% for (var i=0; i<datasets.length; i++){%><span style=\"margin:0 10px 0 10px;text-align:center\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <span style=\"font-size:7pt;\" class=\"text-bold\"><%=datasets[i].label%><%}%></span</span><%}%></div><% %>"
                    };

                    var canvas = $(it.selector).find('#serviceChart').get(0);
                    var ctx = canvas.getContext("2d");
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    it.serviceChart = new Chart(ctx).Bar(data, options);

                    var legend = it.serviceChart.generateLegend();

                    $(it.selector).find('#serviceChartLabels').html(legend).click(function () {
                        ch.exportHandler(it.serviceChart);
                    });
                    $(it.selector).find('#serviceChart').unbind("click").bind("click", function (evt) {
                        if (it.options.window !== "day") {
                            var ord = ch.getOrdinalPositionOfEvent(it.serviceChart, evt);

                            //ChartJS, returns -1 if not BAR/LINE clicked
                            //-1 means that the selected date has no data to display
                            if (ord === -1) {
                                return;
                            }

                            it.setWindow(it.goSmaller(it.options.window));
                            $(it.selector).find(".timegranule-buttons").find("[data-timegranule]").removeClass('active');
                            $(it.selector).find(".timegranule-buttons").find("[data-timegranule='" + it.options.window + "']").addClass('active');
                            it.options.from.add(ord, it.options.window + 's');
                            it.setWindow(it.options.window);
                            it.refresh();
                        }
                    });

                    if (it.viewType === "engagement") {
                        var handlerEngagement = function () {
                            return $.ajaxDefaultQ({
                                url: '/CampaignCloud/Report/averageEngagement',
                                type: 'POST',
                                data: JSON.stringify(it.options.queryOptions),
                                contentType: 'application/json',
                                dataType: 'json'
                            }).done(function (json) {
                            }).fail(function (response) {
                                console.log(response);
                            });
                        };

                        var handlerPieChart = function () {
                            return $.ajaxDefaultQ({
                                url: '/CampaignCloud/Report/getPieChartData',
                                type: 'POST',
                                data: JSON.stringify(it.options.queryOptions),
                                contentType: 'application/json',
                                dataType: 'json'
                            }).done(function (json) {
                            }).fail(function (response) {
                                console.log(response);
                            });
                        };

                        $.when(handlerEngagement(), handlerPieChart()).done(function (engagementResp, pieChartResp) {
                            //Engagement tiles
                            var totalEngagementValue = engagementResp[0] * 100;
                            $("#customer-engagement-bar > div").css("width", totalEngagementValue + "%");
                            $("#customer-engagement-value").text(totalEngagementValue.toFixed(2) + "%");

                            //radar charts Total Counters
                            $("#totalLinksSent").text(pieChartResp[0].TOTAL_LINKS_SENT ? pieChartResp[0].TOTAL_LINKS_SENT : 0);
                            $("#totalVouchersSent").text(pieChartResp[0].TOTAL_VOUCHERS_SENT ? pieChartResp[0].TOTAL_VOUCHERS_SENT : 0);
                            $("#totalFilesSent").text(pieChartResp[0].TOTAL_FILES_SENT ? pieChartResp[0].TOTAL_FILES_SENT : 0);
                            $("#totalSurveysSent").text(pieChartResp[0].TOTAL_SURVEYS_SENT ? pieChartResp[0].TOTAL_SURVEYS_SENT : 0);

                            var surveys = json.surveyInit;
                            var surveysSent = 0;
                            for (var i = 0; i < surveys.length; i++) {
                                surveysSent += surveys[i];
                            }

                            if (it.linkPie) {
                                it.linkPie.destroy();
                            }
                            if (it.voucherPie) {
                                it.voucherPie.destroy();
                            }
                            if (it.filePie) {
                                it.filePie.destroy();
                            }
                            if (it.surveyPie) {
                                it.surveyPie.destroy();
                            }

                            var totalDl = pieChartResp[0].TOTAL_FILES_SENT;
                            var clickedDl = pieChartResp[0].DL[1];
                            var distinctDl = pieChartResp[0].DL[2];
                            var clickedDlPerc = 0;
                            var nonClickedDlPerc = 100;

                            if (totalDl > 0) {
                                clickedDlPerc = (distinctDl / totalDl * 100 ).toFixed(2);
                                nonClickedDlPerc = (100 - clickedDlPerc).toFixed(2);
                            }
                            if (clickedDlPerc > 100) {
                                nonClickedDlPerc = 0;
                            }

                            $(it.selector).find("#file-pie-chart-container").text(i18n.t("reports.filessent", {count: clickedDl}));
                            $(it.selector).find("#report-file-1").text(distinctDl ? distinctDl : 0);
                            var cl = Handlebars.helpers.dynamicFontSize(clickedDl, $(it.selector).find("#report-file-1").data("font-length"));
                            $(it.selector).find("#report-file-1").addClass(cl.toString());
                            $(it.selector).find("#fileTitle").text(i18n.t("dashboard.dl", {count: distinctDl}));

                            var totalLinks = pieChartResp[0].TOTAL_LINKS_SENT;
                            var clickedLinks = pieChartResp[0].URL[1];
                            var distinctLinks = pieChartResp[0].URL[2];
                            var clickedLinksPerc = 0;
                            var nonClickedLinksPerc = 100;

                            if (totalLinks > 0) {
                                clickedLinksPerc = (distinctLinks / totalLinks * 100 ).toFixed(2);
                                nonClickedLinksPerc = (100 - clickedLinksPerc).toFixed(2);
                            }
                            if (clickedLinksPerc > 100) {
                                nonClickedLinksPerc = 0;
                            }

                            $(it.selector).find("#link-pie-chart-container").text(i18n.t("reports.urlssent", {count: clickedLinks}));
                            $(it.selector).find("#report-link-1").text(distinctLinks);
                            cl = Handlebars.helpers.dynamicFontSize(clickedLinks, $(it.selector).find("#report-link-1").data("font-length"));
                            $(it.selector).find("#report-link-1").addClass(cl.toString());
                            $(it.selector).find("#linkTitle").text(i18n.t("dashboard.clicks", {count: distinctLinks}));


                            var totalVouchersSent = pieChartResp[0].TOTAL_VOUCHERS_SENT;
                            var distRedemptions = pieChartResp[0].DISTINCT_REDEMPTIONS;
                            var clickedVouchersPerc = 0;
                            var nonClickedVouchersPerc = 100;

                            if (totalVouchersSent > 0) {
                                clickedVouchersPerc = (distRedemptions / totalVouchersSent * 100 ).toFixed(2);
                                nonClickedVouchersPerc = (100 - clickedVouchersPerc).toFixed(2);
                            }
                            if (clickedVouchersPerc > 100) {
                                nonClickedVouchersPerc = 0;
                            }

                            $(it.selector).find("#voucher-pie-chart-container").text(i18n.t("analytics.vouchersSent", {count: distRedemptions}));
                            $(it.selector).find("#report-voucher-1").text(distRedemptions);
                            cl = Handlebars.helpers.dynamicFontSize(distRedemptions, $(it.selector).find("#report-voucher-1").data("font-length"));
                            $(it.selector).find("#report-voucher-1").addClass(cl.toString());
                            $(it.selector).find("#voucherTitle").text(i18n.t("dashboard.redemption", {count: distRedemptions}));

                            var totalSurveysSent = pieChartResp[0].TOTAL_SURVEYS_SENT;
                            var surveyAnswers = pieChartResp[0].SURVEY_ANSWERS;
                            var surveyAnswerPerc = 0;
                            var nonSurveyAnswerPerc = 100;

                            if (totalSurveysSent > 0) {
                                surveyAnswerPerc = (surveyAnswers / totalSurveysSent * 100 ).toFixed(2);
                                nonSurveyAnswerPerc = (100 - surveyAnswerPerc).toFixed(2);
                            }
                            if (surveyAnswerPerc > 100) {
                                nonSurveyAnswerPerc = 0;
                            }

                            $(it.selector).find("#survey-pie-chart-container").text(i18n.t("reports.Surveyssent", {count: surveyAnswers}));
                            $(it.selector).find("#survey-sum-1").text(surveyAnswers);
                            cl = Handlebars.helpers.dynamicFontSize(surveyAnswers, $(it.selector).find("#survey-sum-1").data("font-length"));
                            $(it.selector).find("#survey-sum-1").addClass(cl.toString());
                            $(it.selector).find("#surveyTitle").text(i18n.t("dashboard.surveyCompleted", {count: surveyAnswers}));

                            var options = {
                                responsive: false,
                                percentageInnerCutout: 75,
                                showTooltips: false,
                                legendTemplate: "<% for (var i=0; i<segments.length; i++){%><h6 style=\"margin:0\"><span style=\"background-color:<%=segments[i].fillColor%>; width:30px; height:10px; display:inline-block\"></span><%if(segments[i].label){%> <%=segments[i].label%><%}%></h6><%}%>"
                            };

                            var dataLinks = [
                                {
                                    value: clickedLinksPerc,
                                    color: "rgba(0,217,148,1)",
                                    label: i18n.t('reports.openedlabel')
                                },
                                {
                                    value: nonClickedLinksPerc,
                                    color: "rgba(72,250,161,1)",
                                    label: i18n.t('reports.notopenedlabel')
                                }
                            ];

                            var linkPie = $(it.selector).find('#linkPie').get(0);
                            var ctxLinkPie = linkPie.getContext("2d");
                            ctxLinkPie.clearRect(0, 0, linkPie.width, linkPie.height);
                            it.linkPie = new Chart(ctxLinkPie).Doughnut(dataLinks, options);
                            var legend = it.linkPie.generateLegend();
                            $(it.selector).find('#linkPieLabels').html(legend).click(function () {
                                ch.exportHandler(it.linkPie);
                            });

                            var dataVouchers = [
                                {
                                    value: clickedVouchersPerc,
                                    color: "rgba(252,73,124,1)",
                                    label: i18n.t('reports.redeemedlabel')
                                },
                                {
                                    value: nonClickedVouchersPerc,
                                    color: "rgba(255,130,172,1)",
                                    label: i18n.t('reports.notredeemedlabel')
                                }
                            ];

                            var voucherPie = $(it.selector).find('#voucherPie').get(0);
                            var ctxVoucherPie = voucherPie.getContext("2d");
                            ctxVoucherPie.clearRect(0, 0, voucherPie.width, voucherPie.height);
                            it.voucherPie = new Chart(ctxVoucherPie).Doughnut(dataVouchers, options);


                            var dataFiles = [
                                {
                                    value: clickedDlPerc,
                                    color: "rgba(207,2,155,1)",
                                    label: i18n.t('reports.downloadedlabel')
                                },
                                {
                                    value: nonClickedDlPerc,
                                    color: "rgba(199,56,170,1)",
                                    label: i18n.t('reports.notdownloadedlabel')
                                }
                            ];

                            var filePie = $(it.selector).find('#filePie').get(0);
                            var ctxFilePie = filePie.getContext("2d");
                            ctxFilePie.clearRect(0, 0, filePie.width, filePie.height);
                            it.filePie = new Chart(ctxFilePie).Doughnut(dataFiles, options);

                            var dataSurveys = [
                                {
                                    value: surveyAnswerPerc,
                                    color: "rgba(255,128,0,1)",
                                    label: i18n.t('reports.completedlabel')
                                },
                                {
                                    value: nonSurveyAnswerPerc,
                                    color: "rgba(250,172,88,1)",
                                    label: i18n.t('reports.notcompletedlabel')
                                }
                            ];

                            var surveyPie = $(it.selector).find('#surveyPie').get(0);
                            var ctxSurveyPie = surveyPie.getContext("2d");
                            ctxSurveyPie.clearRect(0, 0, surveyPie.width, surveyPie.height);
                            it.surveyPie = new Chart(ctxSurveyPie).Doughnut(dataSurveys, options);


                            //set engagement percent values
                            $(it.selector).find("#totalSurveysEngagement").text(parseInt(surveyAnswerPerc) + "%");
                            $(it.selector).find("#totalVouchersEngagement").text(parseInt(clickedVouchersPerc) + "%");
                            $(it.selector).find("#totalLinksEngagement").text(parseInt(clickedLinksPerc) + "%");
                            $(it.selector).find("#totalFilesEngagement").text(parseInt(clickedDlPerc) + "%");

                        });
                    }

                });
            }
            else {
                console.info(response);
                window.open('Login.htm', '_self');
            }
        }).fail(function (response) {
            console.info(response);
            window.open('Login.htm', '_self');
        });
    };

    it.goSmaller = function (timegranule) {
        switch (timegranule) {
            case "week":
                return "day";
            case "month":
                return "day";
            case "year":
                return "month";
            case "all":
                return it.options.unitAll === "day" ? "*day" : it.options.unitAll;
        }
    };

    export default it;
